import { Vue, Component } from 'vue-property-decorator'

@Component
export default class StatusFormatterMixin extends Vue {
  liveIconClass = 'status-live-icon fa-lg'
  reviewIconClass = 'status-in-review-icon fa-lg'
  draftIconClass = 'status-draft-icon fa-lg'
  liveForAllIconClass = 'status-live-for-all-icon fa-lg'
  pausedIconClass = 'status-paused-icon fa-lg'
  archivedIconClass = 'status-archived-icon fa-lg'
  finishedIconClass = 'status-finished-icon fa-lg'

  /*
    Draft = ChoiceItem(1, _("in Progress"))
    Public = ChoiceItem(2, _("complete"))
    Archived = ChoiceItem(3, _("archived"))
    Paused = ChoiceItem(4, _("Paused"))
  */

  fundingPageStatusFormatter(status: number) {
    let iconClass = ''
    let tooltip = ''

    switch (status) {
      case 1:
        iconClass = this.draftIconClass
        tooltip = this.$gettext('Draft')
        break
      case 2:
        iconClass = this.liveIconClass
        tooltip = this.$gettext('Live')
        break
      case 3:
        iconClass = this.archivedIconClass
        tooltip = this.$gettext('Finished')
        break
      case 4:
        iconClass = this.pausedIconClass
        tooltip = this.$gettext('Paused')
        break
      default:
        iconClass = ''
        tooltip = this.$gettext('Unknown status')
    }

    return { icon: iconClass, tooltip }
  }

  projectStatusFormatter(status: {
    live: boolean,
    live_for_all: boolean,
    draft: boolean,
    review: boolean,
    paused: boolean,
    archived: boolean,
    finished: boolean,
    orga_in_review: boolean,
  }): { icon: string, tooltip: string } {
    let iconClass = ''
    let tooltip = ''
    if (status.draft) {
      iconClass = this.draftIconClass
      tooltip = this.$gettext('Draft')
    } else if (status.orga_in_review && !status.archived) {
      iconClass = this.reviewIconClass
      tooltip = this.$gettext('Organization in review')
    } else if (status.live) {
      iconClass = this.liveIconClass
      tooltip = this.$gettext('Live')
    } else if (status.live_for_all) {
      iconClass = this.liveForAllIconClass
      tooltip = this.$gettext('Live for all')
    } else if (status.paused) {
      iconClass = this.pausedIconClass
      tooltip = this.$gettext('Paused')
    } else if (status.archived) {
      iconClass = this.archivedIconClass
      tooltip = this.$gettext('Archived')
    } else if (status.review) {
      iconClass = this.reviewIconClass
      tooltip = this.$gettext('Project in review')
    } else if (status.finished) {
      iconClass = this.finishedIconClass
      tooltip = this.$gettext('Finished')
    }
    return { icon: iconClass, tooltip }
  }
}
